import { render, staticRenderFns } from "./LargeNews.vue?vue&type=template&id=ea246ed4&"
import script from "./LargeNews.vue?vue&type=script&lang=js&"
export * from "./LargeNews.vue?vue&type=script&lang=js&"
import style0 from "./LargeNews.vue?vue&type=style&index=0&id=ea246ed4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports